import { Page } from "containers/Page";
import { TabsGerenciarPagamentos } from "./containers/Tabs";

function GerenciarPagamentos() {
  return (
    <Page title="Pagamentos Operacionais">
      <TabsGerenciarPagamentos />
    </Page>
  );
}

export { GerenciarPagamentos };
